import React, { Component } from "react";
import { connect } from "react-redux";
import { signOut } from "../../user/actions";
import SessionExpired from "../../shared/components/notices/SessionExpired";
import { push } from "react-router-redux";

export class SessionExpiredScreen extends Component {
  constructor(props) {
    super(props);

    this.signOut = this.signOut.bind(this);
  }

  componentDidMount() {
    this.props.signOut();
  }

  signOut() {
    this.props.redirectToLogin();
  }

  render() {
    return <SessionExpired signOut={this.signOut} showRestrictedExpirationMessage={false} />
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut()),
    redirectToLogin: () => dispatch(push('/login')),
  };
};


export default connect(null, mapDispatchToProps)(SessionExpiredScreen);



// WEBPACK FOOTER //
// ./src/features/home/containers/SessionExpiredScreen.js